<template>
  <UiTextTooltip v-if="text" :text="text">
    <button type="button" class="jps-icon-button is-size-6">
      <BaseIcon name="mdi/information-outline" />
    </button>
  </UiTextTooltip>
</template>

<script lang="ts" setup>
interface Props {
  text?: LangString
}
const props = withDefaults(defineProps<Props>(), {})
</script>

<style lang="scss" scoped>
</style>
